import { call, put, takeEvery } from 'redux-saga/effects';
import { fniVerificationSuccess, fniVerificationFailure } from './actions';
import { FNI_VERIFICATION_REQUEST } from './actionTypes';
import DealerService from '../../services/DealerService';

export function* verifyFNICredentials(action) {
  try {
    const result = yield call(
      DealerService.verifyFNICredentials,
      action.payload,
    );
    yield put(fniVerificationSuccess(result));
  } catch (err) {
    yield put(fniVerificationFailure(err));
  }
}

export function* verificationsSaga() {
  yield takeEvery(FNI_VERIFICATION_REQUEST, verifyFNICredentials);
}
